import SendCheckViewContent from './SendCheckViewContent';
import SendCheckViewHeader from './SendCheckViewHeader';
import * as ViewModel from '@/core/presenter/viewModel';

interface IProps {
  trxAddress: string;
  sendAddress: string;
  curculateKrw: string;
  sendAsset: string;
  selectedAsset?: ViewModel.IAsset;
  trxBalance: string;
  fee: number;
  isFeeNotice: boolean;
  onClickBacktoSendView: () => void;
  onClickSendCheckNextBtn: () => void;
  onClickSendCancelBtn: () => void;
}

const SendCheckView = ({
  trxAddress,
  sendAddress,
  curculateKrw,
  sendAsset,
  selectedAsset,
  trxBalance,
  fee,
  isFeeNotice,
  onClickBacktoSendView,
  onClickSendCheckNextBtn,
  onClickSendCancelBtn,
}: IProps) => {
  return (
    <div className="container container_snd_dbs">
      <SendCheckViewHeader onClickBackBtn={onClickBacktoSendView} />
      <SendCheckViewContent
        trxAddress={trxAddress}
        sendAddress={sendAddress}
        curculateKrw={curculateKrw}
        sendAsset={sendAsset}
        selectedAsset={selectedAsset}
        trxBalance={trxBalance}
        fee={fee}
        isFeeNotice={isFeeNotice}
        onClickSendCheckNextBtn={onClickSendCheckNextBtn}
        onClickSendCancelBtn={onClickSendCancelBtn}
      />
    </div>
  );
};

export default SendCheckView;
